import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {AbstractControl, FormBuilder, FormGroup, Validators} from "@angular/forms";
import {UserService} from "../service/user.service";
import {ActivatedRoute, Router} from "@angular/router";
import {PASSWORD_PATTERN} from "../constants/validation.constants";

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrl: './reset-password.component.scss'
})

export class ResetPasswordComponent implements OnInit {

  resetPasswordForm: FormGroup;
  errorMessage: string | null = null;
  token: string | null = null;
  showPassword: boolean;
  showConfirmPassword: boolean;
  isPasswordResetCompleted: boolean = false;
  @ViewChild('confirmPasswordInput') confirmPasswordInput!: ElementRef;
  @ViewChild('passwordInput') passwordInput!: ElementRef;

  constructor(
    private userService: UserService,
    private route: ActivatedRoute,
    private router: Router,
    private formBuilder: FormBuilder,
  ) {
    this.resetPasswordForm = this.createResetPasswordForm();
    this.showPassword = false;
    this.showConfirmPassword = false;
  }

  ngOnInit(): void {
    this.token = this.route.snapshot.queryParams['token'];
    if (!this.token) {
      this.router.navigate(['/error']);
      return;
    }
    this.userService.checkResetPasswordLink(this.token).subscribe({
      next: (response) => {
        if (response === false) {
          this.router.navigate(['/reset-token']);
        }else {
          this.isPasswordResetCompleted = true;
        }
      }
    });
  }

  createResetPasswordForm(): FormGroup {
    return this.formBuilder.group({
      password: ['', [Validators.required, Validators.pattern(PASSWORD_PATTERN)]],
      confirmPassword: ['', [Validators.required]]
    }, {updateOn: 'blur', validator: this.passwordMatchValidator});
  }

  passwordMatchValidator(control: AbstractControl): { passwordMismatch: boolean } | null {
    const password = control.get('password')?.value;
    const confirmPassword = control.get('confirmPassword')?.value;
    return password !== confirmPassword ? {passwordMismatch: true} : null;
  }

  resetPassword() {
    this.resetPasswordForm.markAllAsTouched();
    if (this.resetPasswordForm.invalid || !this.token) {
      return;
    }
    const newPassword = this.resetPasswordForm.get('password')?.value;
    const confirmPassword = this.resetPasswordForm.get('confirmPassword')?.value;
    this.userService.resetPassword(newPassword, confirmPassword, this.token).subscribe({
        next: () => {
          this.router.navigate(['/login']);
        },
        error: () => {
          this.errorMessage = 'Failed to reset password. Please try again.';
        }
      }
    );
  }

  togglePasswordVisibility(field: string): void {
    if (field === 'password') {
      this.showPassword = !this.showPassword;
    } else if (field === 'confirmPassword') {
      this.showConfirmPassword = !this.showConfirmPassword;
    }
  }

  get resetPasswordFormControl() {
    return this.resetPasswordForm.controls;
  }

}
